import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../../../components/Loader';
import NotFound from '../../../../components/NotFound';
import { clientIdPage } from '../../../../constants/pagesRoutesContants';
import { fetchClientCase } from '../../../../services/caseService';
import CaseDetails from '../caseDetails';
import styles from './style.module.scss';

function ClientCase() {
    const { caseId = '' } = useParams();
    const basePath = clientIdPage.path;

    const { data: clientCase, isPending } = useQuery({
        queryKey: ['getUserCase', caseId],
        queryFn: async () => {
            if (!caseId) {
                return null;
            }
            const { data } = await fetchClientCase(caseId);
            return data;
        },
    });

    if (isPending) {
        return <Loader />;
    }

    if (caseId.length === 0) {
        return (
            <>
                <div className={styles.header}>
                    <Link to={basePath}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </Link>
                    <h1>Dossier</h1>
                </div>
                <NotFound />
            </>
        );
    }

    return (
        <CaseDetails
            caseId={caseId}
            userCase={clientCase}
            basePath={basePath + clientCase?.userId}
        />
    );
}

export default ClientCase;
